import { render, staticRenderFns } from "./RZPSceneOptions.vue?vue&type=template&id=04dd987a&scoped=true&"
import script from "./RZPSceneOptions.vue?vue&type=script&lang=ts&"
export * from "./RZPSceneOptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dd987a",
  null
  
)

export default component.exports